module.exports = __webpack_public_path__ + "img/logo_spotify.1fac45c6.png";